import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormControl,
  FormsModule,
  FormArray,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IttSectionDialogsComponent } from '../itt-section-dialogs.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { MatRadioModule } from '@angular/material/radio';
import { environment } from '@/app/environments/environment';
import { FileManagerComponent } from "@/app/components/shared/file-manager/file-manager.component";
import { ActivatedRoute, Router } from '@angular/router';
import { RfpLabelService } from '@/app/components/projects/project-development/tendering/inivitation-to-tender/rfp-labels.service';

@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    RichTextEditorComponent,
    MatRadioModule,
    FileManagerComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-technical-submission',
  templateUrl: './technical-submission.component.html',
  styleUrls: ['./technical-submission.component.css'],
})
export class TechnicalSubmissionComponent implements OnInit {
  base_path = environment.storageUrl;
  resetRichTextEditor = false;
  isEdit = false;
  eoiTitle: FormControl<any>;
  submittedGuidlines: any;
  ittId: number;
  isRFPorRFQ: string;
  labels: any;

  constructor(
    private IttSectionDialogsComponent: IttSectionDialogsComponent,
    private toast: NgToastService,
    private TenderingService: TenderingService,
    private route: ActivatedRoute,
    private rfpLabelService: RfpLabelService,
    private router: Router
  ) {}
  @Output() closeModalEvent = new EventEmitter<boolean>(); // EventEmitter to notify parent
  @Output() technicalSubmissionDataEmitter: EventEmitter<any> =
    new EventEmitter<any>();

  @Input() tendererResponseData: any;

  form: FormGroup = new FormGroup({
    technical_proposal_control: new FormControl('', Validators.required),
    client_name_control1: new FormControl(''),
    location_control1: new FormControl(''),
    project_description_control1: new FormControl(''),
    client_name_control2: new FormControl(''),
    location_control2: new FormControl(''),
    project_description_control2: new FormControl(''),
    client_name_control3: new FormControl(''),
    location_control3: new FormControl(''),
    project_description_control3: new FormControl(''),
    project_programme_control: new FormControl(''),
    health_safety_control: new FormControl(''),
    environmental_sustainability_control: new FormControl(0),
    environmental_sustainability_description: new FormControl(''),
    technical_deviations_control: new FormControl(0),
    technical_deviations_description: new FormControl(''),
    technicalProposalFileControl: new FormArray([]),
    cvsOfKeyPersonalFileControl: new FormArray([]),
    technicalHealthSafetyFileControl: new FormArray([]),
    projectProgrammeFileControl: new FormArray([]),
    relevantExperienceFileControl: new FormArray([]),
    environmentalSustainabilityPlanFileControl: new FormArray([]),
    technicalDeviationsClarificationsFileControl: new FormArray([]),
  });

  closeModal = true;

  oldTechnicalProposalFiles = [];
  deletedOldTechnicalProposalFilesIds = [];
  oldTechnicalHealthSafetyFiles = [];
  deletedOldTechnicalHealthSafetyFilesIds = [];
  oldCvsOfKeyPersonnelFiles = [];
  deletedOldCvsOfKeyPersonnelFilesIds = [];
  oldRelevantExperienceFiles = [];
  deletedOldRelevantExperienceFilesIds = [];
  oldProjectProgrammeFiles = [];
  deletedOldProjectProgrammeFilesIds = [];

  oldEnvironmentalSustainabilityPlanFiles: any[];
  deletedOldEnvironmentalSustainabilityPlanFilesIds: any[];
  oldTechnicalDeviationsClarificationsFiles: any[];
  deletedOldTechnicalDeviationsClarificationsFilesIds: any[];

  ngOnInit(): void {
    // Subscribe to route changes
    this.route.url.subscribe(() => {
      const currentRoute = this.router.url; // Get full URL path
      this.rfpLabelService.updateLabelsFromRoute(currentRoute);
      this.isRFPorRFQ = this.rfpLabelService.updateRFPorRFQFlag(currentRoute);
    });
    this.rfpLabelService.labels$.subscribe((labels) => {
      this.labels = labels;
    });
    this.ittId = this.TenderingService.getIttId();
    this.TenderingService.isEdit$.subscribe((state) => {
      this.isEdit = state;
    });

    if (this.tendererResponseData) {
      this.mapRFPExistingData();
    }
  }

  moveToPreviousStep() {
    this.IttSectionDialogsComponent.previousStep();
  }

  setTechnicalProposal(content: string) {
    this.form.controls['technical_proposal_control'].setValue(content);
  }
  setProjectProgramme(content: string) {
    this.form.controls['project_programme_control'].setValue(content);
  }
  setHealthSafety(content: string) {
    this.form.controls['health_safety_control'].setValue(content);
  }

  prepareDataToSubmit(): FormData {
    if (this.form.valid) {
      const formData = new FormData();

      formData.append(
        'deletedSitePreparationFiles[]',
        JSON.stringify(this.deletedOldCvsOfKeyPersonnelFilesIds)
      );

      // Prepare experience data
      const experience = {
        client_name_control1: this.form.value.client_name_control1,
        location_control1: this.form.value.location_control1,
        project_description_control1:
          this.form.value.project_description_control1,
        client_name_control2: this.form.value.client_name_control2,
        location_control2: this.form.value.location_control2,
        project_description_control2:
          this.form.value.project_description_control2,
        client_name_control3: this.form.value.client_name_control3,
        location_control3: this.form.value.location_control3,
        project_description_control3:
          this.form.value.project_description_control3,
      };

      // Append other form data fields
      formData.append('relevant_experience', JSON.stringify(experience));
      formData.append(
        'technical_proposal',
        this.form.value.technical_proposal_control
      );
      formData.append(
        'project_programme',
        this.form.value.project_programme_control
      );
      formData.append(
        'health_safety_plan',
        this.form.value.health_safety_control
      );
      formData.append(
        'has_environmental_plan',
        this.form.value.environmental_sustainability_control.toString()
      );
      formData.append(
        'environmental_plan_description',
        this.form.value.environmental_sustainability_description
      );
      formData.append(
        'has_technical_deviations',
        this.form.value.technical_deviations_control.toString()
      );
      formData.append(
        'technical_deviations_description',
        this.form.value.technical_deviations_description
      );

      // Files handling Start
      this.addUploadedFiles(formData);
      this.addDeletedOldFilesIds(formData);
      // Files handling End

      return formData;
    }

    throw new Error('Form is invalid. Cannot prepare data for submission.');
  }

    // NOTE: when submitting form, add new files in data
    addUploadedFiles(submissionFormData: FormData) {
      const submissionKeys: Record<string, string> = {
        cvsOfKeyPersonalFileControl: 'cv_of_key_personnel_attach[]',
        technicalProposalFileControl: 'technical_proposal_attach[]',
        technicalHealthSafetyFileControl: 'technical_health_safety_attach[]',
        relevantExperienceFileControl: 'relevant_experience_attach[]',
        projectProgrammeFileControl: 'project_programme_attach[]',
        environmentalSustainabilityPlanFileControl: 'environmental_sustainability_plan_attach[]',
        technicalDeviationsClarificationsFileControl: 'technical_deviations_clarifications_attach[]',
        
      };
    
      Object.entries(this.form.value).forEach(([controlName, uploadedFiles]) => {
        if (Array.isArray(uploadedFiles) && submissionKeys[controlName]) {  
          // Ensure it's a file control and has a corresponding submission key
          uploadedFiles.forEach((file: File) => {
            if (file) {
              submissionFormData.append(submissionKeys[controlName], file);
            }
          });
        }
      });
    }
    

    // NOTE: on submit, append deleted files ids in data
    addDeletedOldFilesIds(submissionFormData: FormData) {
      const deletedFilesMap: Record<string, string> = {
        deletedOldCvsOfKeyPersonnelFilesIds: 'deleted_cvs_of_key_personnel_ids',
        deletedOldTechnicalProposalFilesIds: 'deleted_technical_proposal_ids',
        deletedOldTechnicalHealthSafetyFilesIds: 'deleted_technical_health_safety_ids',
        deletedOldRelevantExperienceFilesIds: 'deleted_relevant_experience_files_ids',
        deletedOldProjectProgrammeFilesIds: 'deleted_project_programme_files_ids',
        deletedOldEnvironmentalSustainabilityPlanFilesIds: 'deleted_environmental_sustainability_plan_files_ids',
        deletedOldTechnicalDeviationsClarificationsFilesIds: 'deleted_technical_deviations_clarifications_files_ids'
      };
    
      Object.entries(deletedFilesMap).forEach(([property, submissionKey]) => {
        if (this[property]?.length > 0) {
          submissionFormData.append(submissionKey, JSON.stringify(this[property]));
        }
      });
    }
    

  moveToNextStep() {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      this.toast.warning(
        'Please fill in all required fields.',
        'WARNING',
        4000
      );
      return;
    }
    const dataToSubmit = this.prepareDataToSubmit();
    this.TenderingService.addRFPApplicantTechnicalSubmissionDetails(
      dataToSubmit,
      this.ittId
    ).subscribe({
      next: (response) => {
        if (!response?.meta?.success) {
          return;
        }

        this.toast.success('Technical Submission Done', 'SUCCESS');
        this.technicalSubmissionDataEmitter.emit(response?.data);
        this.IttSectionDialogsComponent.nextStep();
      },
      error: (error: any) => {
        console.error('Failed to submit:', error);
        this.toast.danger(error.error.message, 'DANGER', 4000);
      },
    });
  }
  handleBack() {
    this.IttSectionDialogsComponent.previousStep();
  }

  mapRFPExistingData() {
    if (!this.tendererResponseData) {
      console.warn('Tenderer Response Data is undefined');
      return;
    }

    this.form.patchValue({
      client_name_control1: this.tendererResponseData?.relevantExperience?.client_name_control1 ?? '',
      location_control1: this.tendererResponseData?.relevantExperience?.location_control1 ?? '',
      project_description_control1:
        this.tendererResponseData?.relevantExperience?.project_description_control1 ?? '',
      client_name_control2: this.tendererResponseData?.relevantExperience?.client_name_control2 ?? '',
      location_control2: this.tendererResponseData?.relevantExperience?.location_control2 ?? '',
      project_description_control2:
        this.tendererResponseData?.relevantExperience?.project_description_control2 ?? '',
      client_name_control3: this.tendererResponseData?.relevantExperience?.client_name_control3 ?? '',
      location_control3: this.tendererResponseData?.relevantExperience?.location_control3 ?? '',
      project_description_control3:
        this.tendererResponseData?.relevantExperience?.project_description_control3 ?? '',

      technical_proposal_control:
        this.tendererResponseData?.technicalProposal ?? '',
      project_programme_control:
        this.tendererResponseData?.projectProgramme ?? '',
      health_safety_control: this.tendererResponseData?.healthSafetyPlan ?? '',
      environmental_sustainability_control:
        Number(this.tendererResponseData?.hasEnvironmentalPlan) || 0,
      environmental_sustainability_description:
        this.tendererResponseData?.environmentalPlanDescription ?? '',
      technical_deviations_control:
        Number(this.tendererResponseData?.hasTechnicalDeviations) || 0,
      technical_deviations_description:
        this.tendererResponseData?.technicalDeviationsDescription ?? '',
    });

    this.oldCvsOfKeyPersonnelFiles =
      this.tendererResponseData?.cvsOfKeyPersonnelsAttachments ?? [];
    this.oldTechnicalProposalFiles =
      this.tendererResponseData?.technicalProposalAttachments ?? [];
    this.oldTechnicalHealthSafetyFiles =
      this.tendererResponseData?.technicalHealthSafetyAttachments ?? [];
    this.oldRelevantExperienceFiles =
      this.tendererResponseData?.relevantExperienceAttachments ?? [];
    this.oldProjectProgrammeFiles =
      this.tendererResponseData?.projectProgrammeAttachments ?? [];

    this.oldEnvironmentalSustainabilityPlanFiles =
      this.tendererResponseData?.environmentalSustainabilityPlanAttachments ?? [];
    this.oldTechnicalDeviationsClarificationsFiles =
      this.tendererResponseData?.technicalDeviationsClarificationsAttachments ?? [];
  }

  /**
   * Handling File Operations - START
   */
  // Uploading/Deleting new files for site preparation
  handleNewFiles(filesData: { files: File[]; controlName: string; isEmpty: boolean }) {
    const fileArray = this.form.get(filesData.controlName) as FormArray;
    if (!fileArray) return; // Ensure the control exists
  
    fileArray.clear();
    
    if (filesData.isEmpty) return;
  
    filesData.files.forEach(file => fileArray.push(new FormControl(file)));
  }
  

  // Uploading/Deleting new files for site preparation
  handleDeletedOldFiles(OldFileData: any) {
    switch (OldFileData.controlName) {
      case 'cvsOfKeyPersonalFileControl': {
        this.deletedOldCvsOfKeyPersonnelFilesIds.push(OldFileData?.file?.id);
        this.oldCvsOfKeyPersonnelFiles = this.oldCvsOfKeyPersonnelFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }

      case 'technicalProposalFileControl': {
        this.deletedOldTechnicalProposalFilesIds.push(OldFileData?.file?.id);
        this.oldTechnicalProposalFiles = this.oldTechnicalProposalFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }

      case 'technicalHealthSafetyFileControl': {
        this.deletedOldTechnicalHealthSafetyFilesIds.push(OldFileData?.file?.id);
        this.oldTechnicalHealthSafetyFiles = this.oldTechnicalHealthSafetyFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }
      
      case 'relevantExperienceFileControl': {
        this.deletedOldRelevantExperienceFilesIds.push(OldFileData?.file?.id);
        this.oldRelevantExperienceFiles = this.oldRelevantExperienceFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }

      case 'projectProgrammeFileControl': {
        this.deletedOldProjectProgrammeFilesIds.push(OldFileData?.file?.id);
        this.oldProjectProgrammeFiles = this.oldProjectProgrammeFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }
      default:
        break;
    }
  }
  /**
   * Handling File Operations - END
   */
}
